export default "__VITE_ASSET__Bbj$dSA6__"